// 平台管理员
import {getRoles} from '@/utils/cookie'
import {
  business,
  doctorPrefix,
  memberPrefix,
  operatorPrefix,
  platform,
  platformUserPrefix,
  tenantUserPrefix
} from '@/api/common'

export const platformUser = 'platformUser'

// 租户
export const tenantUser = 'tenantUser'

// 诊所代理人
export const operator = 'operator'

// 医生
export const doctor = 'doctor'

// 就诊人
export const member = 'member'

/**
 * 根据角色获取服务名
 */
export const getBackendByRole = () => {
  return getRoles() === platformUser ? platform : business
}

/**
 * 根据角色获取Authorization
 */
export const getAuthorizationByRole = () => {
  return getRoles() === platformUser ? 'Basic cGxhdGZvcm06MTIzNDU2' : 'Basic dGVuYW50OjEyMzQ1Ng=='
}
/**
 * 根据角色获取url前缀
 * @returns {string}
 */
export const getUrlPrefixByRole = () => {
  let roles = getRoles()
  if (roles === platformUser) {
    return platformUserPrefix
  } else if (roles === tenantUser) {
    return tenantUserPrefix
  } else if (roles === operator) {
    return operatorPrefix
  } else if (roles === doctor) {
    return doctorPrefix
  } else if (roles === member) {
    return memberPrefix
  }
}



// WEBPACK FOOTER //
// ./src/utils/role/index.js